import {ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, OnInit, Output} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {FormControl, FormGroup} from '@angular/forms';

import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';

import {UserService} from '@core/ecv-http-services/services/user.service';
import {CvParsedModel} from '../cvs/cv.parsed.model';
import {CvsModel} from '../cvs/cvs.model';
import {CvsUtils} from '../cvs/cvs.utils';
import {CustomValidators} from '@core/validator/custom-validators';
import {ValidatorService} from '@core/validator/validator.service';
import {AlertService} from '@widgets/alert/alert.service';
import {Repository} from '../network/repository.enum';
import {SocialMedia} from '../network/social-media.enum';
import {FileSaverService} from '../shared/file-saver-service';
import DateUtils from '../shared/date-utils';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import {SemanticEnrichmentService} from '../core/ecv-http-services/services/semantic-enrichment.service';
import {DialogWikipediaAnchorsComponent} from '../ecv-project/dialog/dialog.wikipedia-anchors/dialog.wikipedia-anchors.component';


@Component({
  selector: 'app-dialog-parse-cv',
  templateUrl: './dialog.parse.cv.component.html'
})
export class DialogParseCvComponent implements OnInit {
  static windowYOffset: number;
  parseCvForm: FormGroup;
  model: CvParsedModel;
  show: boolean;
  @Output() cvParsed = new EventEmitter();
  cvModel: CvsModel;
  cvContent: SafeResourceUrl;
  windowWidth: number;

  constructor(public activeModal: NgbActiveModal,
              public changeRef: ChangeDetectorRef,
              private userService: UserService,
              private translateService: TranslateService,
              private alertService: AlertService,
              private validatorService: ValidatorService,
              private sanitizer: DomSanitizer,
              private fileSaverService: FileSaverService,
              private spinnerService: Ng4LoadingSpinnerService,
              private semanticEnrichmentService: SemanticEnrichmentService,
              private modalService: NgbModal,
              private elementRef: ElementRef) {
    this.windowWidth = window.innerWidth;
    DialogParseCvComponent.windowYOffset = 0;
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize($event) {
    this.windowWidth = $event.target.innerWidth;
  }

  ngOnInit(): void {
    const dialog = this.elementRef.nativeElement.parentElement.parentElement.parentElement;
    dialog.onscroll = function (param) {
      DialogParseCvComponent.windowYOffset = dialog.scrollTop;
    };
    this.parseCvForm = new FormGroup({
      'firstName': new FormControl(''),
      'lastName': new FormControl(''),
      'email': new FormControl('', CustomValidators.validateNotEmptyEmail),
      'phone': new FormControl('')
    });
    this.cvModel = new CvsModel();
    this.cvModel.id = this.model.cvId;
    this.cvModel.fileName = this.model.cvFileName;
    this.cvModel.content = this.model.cvContent;
    this.cvContent = this.sanitizer.bypassSecurityTrustResourceUrl(this.getFileUrlFromCv());
  }

  close() {
    this.activeModal.close(false);
  }

  save() {
    this.validatorService.validate(this.parseCvForm);
    if (!this.validatorService.isValid(this.parseCvForm)) {
      this.translateService.get('ALERT.FIX_ERRORS', {}).subscribe((res: string) => {
        this.alertService.error(res);
      });
      return;
    }
    this.setDateFormats();
    this.userService.saveParsedCv(this.model).subscribe(
      response => {
        this.translateService.get('ALERT.PARSED_CV_SAVED', {}).subscribe((res: string) => {
          this.alertService.success(res);
          this.cvParsed.emit();
          this.close();
        });
      });
  }

  dismiss(s: string) {
    this.activeModal.dismiss(s);
  }

  hasAtLeastOneCorrectEducation(): boolean {
    return this.model.education && this.model.education.filter(x => x.accepted).length > 0;
  }

  hasAtLeastOneCorrectExperience(): boolean {
    return this.model.experience && this.model.experience.filter(x => x.accepted).length > 0;
  }

  hasAtLeastOneCorrectSkill(): boolean {
    return this.model.competences && this.model.competences.filter(x => x.accepted).length > 0;
  }

  hasAtLeastOneCorrectSocialMedia(): boolean {
    return this.model.socialMedia && this.model.socialMedia.filter(x => x.accepted).length > 0;
  }

  hasAtLeastOneCorrectRepository(): boolean {
    return this.model.repositories && this.model.repositories.filter(x => x.accepted).length > 0;
  }

  private getFileUrlFromCv(): string {
    return CvsUtils.getFileURL(this.cvModel.content);
  }

  public objectSupported(): boolean {
    return !(CvsUtils.detectBrowserSupportsPdfPreview() > 0);
  }

  public downloadCV() {
    this.fileSaverService.saveCvFile(this.cvModel.id);
  }

  public showWikipediaAnchors() {
    this.spinnerService.show();
    this.semanticEnrichmentService.getWikipediaAnchors(this.cvModel.id).subscribe(
      (response) => {
        this.spinnerService.hide();
        const modalRef = this.modalService.open(DialogWikipediaAnchorsComponent);
        modalRef.componentInstance.model = response;
      },
      () => {
        this.spinnerService.hide();
      })
  }

  public scrollYPosition() {
    if (this.windowWidth < 992) {
      return 0;
    }
    return Math.max(DialogParseCvComponent.windowYOffset - 150, 0);
  }

  getRepositoryEnum() {
    return Repository;
  }

  getSocialMediaEnum() {
    return SocialMedia;
  }

  isUserDataNumberType(serviceNumber: number) {
    return serviceNumber === 2;
  }

  private setDateFormats() {
    for (let education of this.model.education) {
      education.from.dateFormat = DateUtils.parseDateFormat(education.from.date);
      education.to.dateFormat = DateUtils.parseDateFormat(education.to.date);
    }
    for (let experience of this.model.experience) {
      experience.from.dateFormat = DateUtils.parseDateFormat(experience.from.date);
      experience.to.dateFormat = DateUtils.parseDateFormat(experience.to.date);
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/dialog/dialog.parse.cv.component.ts